import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSync = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4a8 8 0 0 1 -13.78-5.51 1 1 0 0 0 -2 0 10 10 0 0 0 16.88 7.23v1.77a1 1 0 0 0 2 0v-4.5a1 1 0 0 0 -.97-.99zm-7.91-13.51a10 10 0 0 0 -6.88 2.77v-1.77a1 1 0 0 0 -2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4a8 8 0 0 1 13.78 5.5 1 1 0 0 0 2 0 10 10 0 0 0 -10-10z" })
});
export default SvgSync;
